export default "__VITE_ASSET__DZYcClND__"